import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 513 473" {...props}>
      <title>{props.title || 'Film'}</title>
      <g>
        <path d="M477.8.2v49.1h-55v-49.1h-34.8v72.1h-263.2v-72.1h-34.7v49.1h-54.8v-49.1h-34.8v472h34.8v-49.6h54.8v49.6h34.7v-71.6h263.2v71.6h34.8v-49.6h55v49.6h34.7v-472h-34.7zm-387.7 395.8h-54.8v-49.6h54.8v49.6zm0-83.1h-54.8v-49.1h54.8v49.1zm0-91.4h-54.8v-49.1h54.8v49.1zm0-92.3h-54.8v-49.1h54.8v49.1zm34.7 217.2v-217.2h263.2v217.2h-263.2zm353 49.6h-55v-49.6h55v49.6zm0-83.1h-55v-49.1h55v49.1zm0-91.4h-55v-49.1h55v49.1zm0-92.3h-55v-49.1h55v49.1z" />
      </g>
    </Icon>
  )
}
